module.exports = __webpack_public_path__ + "static_portal/media/actor_at_erg_spain.b3e8bbb0.mp4";